<button (click)="onClick()" class="h3" data-testid="button">
  <ng-content />
</button>
